export const permissionNames = ['changeImei', 'changeDeviceType', 'changeDeviceSubType', 'users',
    'organisations', 'deviceRegister', 'monitoring', 'serviceText', 'roleCrossSiteDeviceMove',
    'allOrganisationsEdit', 'allUsersEdit'] as const;
type Permission = typeof permissionNames[number];

/** Missing or malformed permissions never enable an action. Server authorization remains authoritative. */
export function normalizePermissions(value: unknown): Record<Permission, boolean> {
    const source = value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {};
    const result = {} as Record<Permission, boolean>;
    for (const name of permissionNames) result[name] = source[name] === true;
    return result;
}
